<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('close')">
        <div class="modal-container" @click.stop>
          <div class="modal-header d-sm-block d-none">
            <slot name="header"> <h1>Watch Details</h1> </slot>
          </div>

          <div class="d-sm-none">
            <b-button-close @click="$emit('close')"/>
            <h4>Watch Details</h4>
          </div>

          <div class="modal-body">
            <slot name="body">
              <b-row>
                <b-col cols="12" sm="4" class="col-image">
                  <b-row class="justify-content-center">
                    <b-col cols="6" sm="12">
                      <div class="image" :style="{ backgroundImage: 'url(' + watchImage + ')' }"></div>
                    </b-col>
                    <b-col cols="6" sm="12" class="text-center col-btn-bid" v-if="isNotEmpty(btnText)">
                      <b-button variant="success" size="lg" @click="openFormModal">
                        {{ btnText }}
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" sm="8">
                  <detail-modal-row
                    v-for="watchDataEntry in watchData"
                    v-bind:key="watchDataEntry.key"
                    :rowKey="watchDataEntry.key"
                    :rowValue="watchDataEntry.value"
                    :boolean-type="watchDataEntry.booleanType"
                  ></detail-modal-row>
                </b-col>
              </b-row>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer text-right">
              <b-button variant="primary" @click="$emit('close')">
                Close
              </b-button>
            </slot>
          </div>
        </div>
      </div>
      <bid-form @cancel="closeFormModal" v-if="showFormModal && type === 'watch'" :watch="watch"></bid-form>
      <offer-form @cancel="closeFormModal" v-if="showFormModal && type === 'demand'" :demand="watch"></offer-form>
    </div>
  </transition>
</template>

<script>
import BidForm from 'src/components/selling/BidForm';
import OfferForm from 'src/components/demand/OfferForm';
import DetailModalRow from 'src/components/WatchDetailModal/components/DetailModalRow';

export default {
  name: 'WatchDetailModal',
  components: {
    DetailModalRow,
    BidForm,
    OfferForm,
  },
  props: {
    watch: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    btnText: {
      type: String,
    },
  },
  data: function() {
    return {
      showFormModal: false,
    };
  },
  methods: {
    openFormModal() {
      this.showFormModal = true;
      this.$ga.event({
        eventCategory: this.type === 'watch' ? 'WatchDetail' : 'DemandDetail',
        eventAction: this.type === 'watch' ? 'click_reserve_button' : 'click_make_offer_button',
        eventLabel:
          this.type === 'watch'
            ? 'Open BidForm for watch ' + this.watch['itemId']
            : 'Open OfferForm for demand ' + this.watch['itemId'],
      });
    },
    closeFormModal() {
      this.showFormModal = false;
      this.$ga.event({
        eventCategory: this.type === 'watch' ? 'BidForm' : 'OfferForm',
        eventAction: this.type === 'watch' ? 'click_bidform_background' : 'click_offer_form_background',
        eventLabel:
          this.type === 'watch'
            ? 'Close BidForm for watch ' + this.watch['itemId']
            : 'Close OfferForm for demand ' + this.watch['itemId'],
      });
    },
    isNotEmpty(str) {
      return str !== undefined && str.length > 0;
    },
  },
  computed: {
    watchData() {
      return this.type === 'watch'
        ? [
            { key: 'Brand', value: this.watch.brand },
            {
              key: 'Model',
              value: this.watch.model !== undefined ? this.watch.model : '',
            },
            { key: 'Year', value: this.watch.year },
            { key: 'Reference', value: this.watch.reference },
            { key: 'Bracelet', value: this.watch.bracelet },
            { key: 'Case', value: this.watch.case },
            { key: 'Dial', value: this.watch.dial },
            { key: 'Cystal', value: this.watch.crystal },
            { key: 'Dial Color', value: this.watch.dialColor },
            { key: 'Condition', value: this.watch.condition },
            {
              key: 'Certificate',
              value: this.watch.certificate,
              booleanType: true,
            },
            { key: 'Box', value: this.watch.box, booleanType: true },
            { key: 'Tax Type', value: this.watch.taxType },
            { key: 'Description', value: this.watch.description.en },
            { key: 'Comments', value: this.watch.comment },
            { key: 'Net Price', value: this.watch.offerPrice + ' EUR' },
          ]
        : [
            { key: 'Brand', value: this.watch.brand },
            { key: 'Variant', value: this.watch.variantKey },
            {
              key: 'Model',
              value: this.watch.model !== undefined ? this.watch.model : '',
            },
            { key: 'Reference', value: this.watch.referenceNumber },
            { key: 'Bracelet', value: this.watch.bracelet },
            { key: 'Dial', value: this.watch.dial },
            { key: 'Dial Color', value: this.watch.dialColor },
            { key: 'Demanded quantity', value: this.watch.amount },
          ];
    },
    watchImage() {
      return encodeURI(
        this.watch.image !== undefined
          ? this.watch.image.replace('cdn-products.chronext.com', 'chronexttime.imgix.net') +
              '?w=226&auto=format&fm=jpg&q=55&usm=50&usmrad=1.5&dpr=2&fit=clamp'
          : this.watch.imageUrl !== undefined
          ? this.watch.imageUrl.replace('cdn-products.chronext.com', 'chronexttime.imgix.net') +
            '?w=226&auto=format&fm=jpg&q=55&usm=50&usmrad=1.5&dpr=2&fit=clamp'
          : '',
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.col-btn-bid {
  margin-top: 20px;
}

.col-image {
  @media (min-width: 576px) {
    padding: 25px 15px;
  }

  padding: 15px 15px;
}

.image {
  @media (min-width: 576px) {
    height: 200px;
  }

  display: inline-block;
  height: 200px;
  width: 100%;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}
</style>
